<template>
  <div>
    <template v-if="checklistItem">
      <evd-form
        ref="evdForm"
        :checklistItem="checklistItem"
        :disabled="!checklistItemIsNew"
        disable-title
        @form-valid="formValid = $event"
      >
        <v-card-actions class="pa-sm-0 mr-sm-4 justify-end">
          <template v-if="checklistItemIsNew === false">
            <v-btn
              text
              @click="checklistItem = null"
              :block="$vuetify.breakpoint.xsOnly"
            >
              <span>Close</span>
            </v-btn>
          </template>
          <template v-else>
            <v-btn text @click="checklistItem = null">Cancel</v-btn>
            <v-btn
              class="save-changes-button"
              color="primary"
              :disabled="!formValid"
              @click="
                save(true);
                checklistItem = null;
              "
              >Submit</v-btn
            >
          </template>
        </v-card-actions>
      </evd-form>
    </template>
    <template v-else>
      <div class="text-right mb-4">
        <yellow-button color="primary" @click="loadForm">
          Add Disclosure
        </yellow-button>
      </div>
      <v-container v-if="revisionsRequested.length">
        <v-row>
          <div
            class="v-alert v-sheet theme--light v-alert--border v-alert--dense v-alert--outlined v-alert--text v-alert--border-left orange--text"
          >
            <span>
              Your customer has requested changes. Please add a new disclosure
              and make the following corrections:
            </span>
            <ul>
              <li
                v-for="revisionRequest in revisionsRequested"
                v-bind:key="revisionRequest"
              >
                {{ revisionRequest }}
              </li>
            </ul>
          </div>
        </v-row>
      </v-container>

      <v-data-table
        class="main-table"
        :headers="headers"
        :items="items"
        hide-default-footer
        disable-sort
        :options="tableOptions"
      >
        <template v-slot:item.submissionDate="{ value }">
          {{ value | formatDate("MM/dd/yyyy HH:mm") }}
        </template>
        <template v-slot:item.action="{ item }">
          <v-btn
            height="32px"
            min-width="32px"
            class="tertiary"
            depressed
            @click="viewHistory(item.metaData)"
          >
            <v-icon color="primary">mdi-arrow-right</v-icon>
          </v-btn>
        </template>
      </v-data-table>
    </template>
  </div>
</template>

<script>
import YellowButton from "@/components/providertrust/buttons/SmallYellowButton";
import { get } from "@/services/request";
import { evdHistoryAPI, lastChecklistItemAPI } from "@/services/api";
import EvdForm from "@/components/EvdForm";
import hasNotifications from "@/mixins/has-notifications";
import { formatDate } from "@/services/format";
import cloneDeep from "lodash/cloneDeep";

const tableOptions = {
  itemsPerPage: -1
};

const headers = [
  { text: "Submission Date", value: "submissionDate" },
  { text: "User Submitted", value: "username" },
  { text: " ", value: "action", align: "end" }
];

export default {
  name: "EvdHistorical",
  mixins: [hasNotifications],
  props: ["customerId", "configId", "evdId"],

  data: () => ({
    headers,
    tableOptions,
    items: [],
    revisionsRequested: [],
    checklistItem: null,
    checklistItemIsNew: false,
    formValid: false
  }),
  created() {
    this.loadHistory();
  },
  methods: {
    viewHistory(checklistItem) {
      // we need to make a copy because somehow data gets altered even in non edit mode
      this.checklistItemIsNew = false;
      this.checklistItem = cloneDeep(checklistItem);
    },
    loadHistory() {
      get(evdHistoryAPI, {
        evdId: this.evdId
      }).then(response => {
        if (response && response.data) {
          this.items = response.data.disclosures;
          this.revisionsRequested = response.data.revisionsRequested;
        }
      });
    },
    loadForm() {
      get(lastChecklistItemAPI.getUrl(this.customerId), {
        configId: this.configId
      }).then(response => {
        if (response && response.data) {
          this.checklistItem = response.data;
          this.checklistItemIsNew = true;
        }
      });
    },
    save(markComplete) {
      const savePromise = this.$refs.evdForm.save(markComplete);
      if (markComplete) {
        savePromise.then(() => this.loadHistory());
      }
      savePromise.finally(() => (this.checklistItem = null));
    }
  },
  components: {
    YellowButton,
    EvdForm
  },
  filters: {
    formatDate
  }
};
</script>

<style lang="sass" scoped>
.card-with-highlight
  border-top-width: 4px !important
</style>
